// ─── Helpers de vale-presente ─────────────────────────────────────────────────
function pareceCartaoPresente(codigo) {
  var trimado = codigo.trim();
  return (
    /^[A-Za-z0-9]{4}-[A-Za-z0-9]{4}-[A-Za-z0-9]{4}-[A-Za-z0-9]{4}$/.test(trimado) ||
    /^[A-Za-z0-9]{4} [A-Za-z0-9]{4} [A-Za-z0-9]{4} [A-Za-z0-9]{4}$/.test(trimado) ||
    /^[A-Za-z0-9]{16}$/.test(trimado)
  );
}

function normalizarCodigoGiftCard(codigo) {
  var limpo = codigo.trim().replace(/[\s-]/g, '');
  return limpo.slice(0,4) + '+' + limpo.slice(4,8) + '+' + limpo.slice(8,12) + '+' + limpo.slice(12,16);
}

// Atualiza o botão "Finalizar Compra" da PÁGINA DE CARRINHO (se existir nesta página).
// O botão do slider não precisa de pré-atualização: ele lê a sessionStorage
// diretamente no momento do clique (ver listener abaixo).
function atualizarDataHrefCarrinho(codigoNormalizado) {
  var cartBtn = document.getElementById('cart-checkout');
  if (!cartBtn) return;
  var base = (cartBtn.getAttribute('data-href') || '/checkout').split('?')[0];
  cartBtn.setAttribute('data-href', base + '?discount=' + codigoNormalizado);
}

function mostrarHintsGiftCard() {
  document.querySelectorAll('.hint-cartao-presente').forEach(function(h) {
    h.style.display = 'block';
  });
}

// ─── Restauração central do estado do vale-presente ───────────────────────────
// Única fonte de verdade: sessionStorage. Chamada toda vez que algo pode ter
// "resetado" o HTML visualmente (refresh do slider via AJAX, por exemplo).
function restaurarEstadoGiftCard() {
  if (sessionStorage.getItem('giftcard_hint_shown') === 'true') {
    mostrarHintsGiftCard();
  }
  var gc = sessionStorage.getItem('giftcard_discount');
  if (gc) {
    atualizarDataHrefCarrinho(gc);
  }
}

// ─── MutationObserver: corrige o "reset visual" causado por refresh do AJAX ───
// Sempre que o tema substitui o HTML do slider (após aplicar cupom, adicionar
// produto, mudar quantidade, remover item, etc.), o hint volta ao estado padrão
// do Liquid (display:none). Esse observer detecta a mudança e restaura o estado
// correto, sem precisar saber qual função específica do tema disparou o refresh.
var _gcRestoreTimeout = null;
function _agendarRestauracaoGiftCard() {
  if (_gcRestoreTimeout) return;
  _gcRestoreTimeout = setTimeout(function() {
    restaurarEstadoGiftCard();
    _gcRestoreTimeout = null;
  }, 50);
}

// ─── Clique no botão checkout do slider ───────────────────────────────────────
// Substitui o onclick inline removido no halo-side-cart.liquid.
// CONSUMO ÚNICO: lê o código da sessão, usa para montar a URL, e IMEDIATAMENTE
// apaga 'giftcard_discount' da sessão. Assim, se o cliente voltar ao site e
// clicar em "Finalizar Compra" de novo, o vale-presente NÃO é reinserido —
// exatamente como já acontece hoje com cupom via AJAX (se removido manualmente
// no checkout, só volta se for reaplicado pelo botão "Aplicar").
document.addEventListener('click', function(event) {
  var btn = event.target.closest('#cart-sidebar-checkout');
  if (!btn || btn.disabled) return;
  event.preventDefault();

  var baseUrl = btn.dataset.checkoutUrl || '/checkout';
  var gc = sessionStorage.getItem('giftcard_discount');

  if (gc) {
    sessionStorage.removeItem('giftcard_discount'); // consumo único
    window.location = baseUrl + '?discount=' + gc;
  } else {
    window.location = baseUrl;
  }
});

// ─── Inicialização ──────────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', function() {
  restaurarEstadoGiftCard();

  var observer = new MutationObserver(_agendarRestauracaoGiftCard);
  observer.observe(document.body, { childList: true, subtree: true });
});

// ─── Classes ──────────────────────────────────────────────────────────────────

class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click',(event) => {
        const id = event.target.dataset.popup;
        document.getElementById(id).classList.add('show');
        document.querySelector('.previewCart').classList.add('active-tool');
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    this.querySelector('button').addEventListener('click',(event) => {
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

class CouponCode extends HTMLElement {
  constructor() {
    super();
    if (localStorage.getItem('storedDiscount')){
      this.querySelector('input[name="discount"]').value = localStorage.getItem('storedDiscount');
    }
    this.querySelector('[data-update-coupon]').addEventListener('click', (event) => {
      this.val = this.querySelector('input[name="discount"]').value.trim();

      // ── Vale-presente detectado ────────────────────────────────────────────
      if (pareceCartaoPresente(this.val)) {
        const codigoNormalizado = normalizarCodigoGiftCard(this.val);
        sessionStorage.setItem('giftcard_discount', codigoNormalizado);
        sessionStorage.setItem('giftcard_hint_shown', 'true');
        atualizarDataHrefCarrinho(codigoNormalizado);
        mostrarHintsGiftCard();
        this.querySelector('input[name="discount"]').value = '';
        return; // Bloqueia AJAX — não processa como cupom
      }

      // ── Cupom normal: fluxo original ──────────────────────────────────────
      localStorage.setItem('storedDiscount', this.val);
      fetch(`/discount/${this.val}`)
          .then((response) => response.text())
          .then((responseText) => {
              const toolPopup = document.querySelector('.popup-toolDown.show');
              if (toolPopup) toolPopup.classList.remove('show');
              const previewCart = document.querySelector('.previewCart');
              if (previewCart) previewCart.classList.remove('active-tool');
              if (window.Shopify && Shopify.getCart) {
                  Shopify.getCart((cart) => { window.sharedFunctions?.updateSidebarCart(cart) });
              }
          });
    });
  }
}

customElements.define('coupon-code', CouponCode);